module.exports = __webpack_public_path__ + "img/dog@2x.d8912b73.png";